
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyBarrelWest as ObiBuoyBarrelWestElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-barrel-west.js';
 
 
 

 
 export const ObiBuoyBarrelWest = createComponent({
   react: React,
   tagName: 'obi-buoy-barrel-west',
   elementClass: ObiBuoyBarrelWestElement,
   events: {
     
   }
  });
 
 